// extracted by mini-css-extract-plugin
export var container = "_5v-0";
export var fallback = "_5v-5";
export var fallbackIcon = "_5v-6";
export var hidden = "_5v-2";
export var image = "_5v-3";
export var loaded = "_5v-4";
export var placeholder = "_5v-1";